"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const offline_mode_1 = require("../organisms/offline-mode");
const hooks_1 = require("../shared/hooks");
const useRWD_1 = __importDefault(require("../shared/hooks/useRWD"));
exports.default = ({ children, offlineMessage, topBar, dashboard }) => {
    const { isOffline } = (0, hooks_1.useNetwork)();
    const { isMobile } = (0, useRWD_1.default)();
    return ((0, jsx_runtime_1.jsxs)(Container, { isOffline: isOffline, dashboard: Boolean(dashboard), className: "form-container", children: [!dashboard && !isMobile && ((0, jsx_runtime_1.jsx)(TopNavigationWrapper, { children: topBar }, void 0)), isOffline && offlineMessage && ((0, jsx_runtime_1.jsx)(OfflineWrapper, { children: (0, jsx_runtime_1.jsx)(offline_mode_1.OfflineNotification, {}, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(Main, { children: children }, void 0)] }, void 0));
};
const Container = styled_components_1.default.div `
  height: calc(
    100vh - ${({ isOffline }) => (isOffline ? "20px" : "0px")}
  );
  width: 100vw;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > nav {
      display: none;
    }
  }
`;
const TopNavigationWrapper = styled_components_1.default.nav `
  height: 49px;
  width: 100%;
`;
const OfflineWrapper = styled_components_1.default.div `
  height: 20px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    top: 0;
  }
`;
const Main = styled_components_1.default.main `
  display: flex;
  height: calc(100% - 49px);
`;
//# sourceMappingURL=BaseTemplate.js.map